"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _classLib = require("class-lib");
var _Content = _interopRequireDefault(require("../molecules/Content.js"));
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["show", "isModal", "center", "content", "className", "children", "contentStyle"]; // @ts-check
/**
 * @param {{
 * className?: string,
 * show?: boolean,
 * isModal?: boolean,
 * center?: boolean,
 * content?: boolean,
 * children?: React.ReactNode,
 * contentStyle?: React.CSSProperties,
 * [key: string]: any
 * }} props
 */
var Dimmer = function Dimmer(props) {
  var _props$show = props.show,
    show = _props$show === void 0 ? false : _props$show,
    _props$isModal = props.isModal,
    isModal = _props$isModal === void 0 ? false : _props$isModal,
    _props$center = props.center,
    center = _props$center === void 0 ? true : _props$center,
    _props$content = props.content,
    content = _props$content === void 0 ? true : _props$content,
    className = props.className,
    children = props.children,
    contentStyle = props.contentStyle,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded);
  if (!show) {
    return null;
  }
  var classes = (0, _classLib.mixClass)(className, "transition visible active", {
    dimmer: !isModal,
    modal: isModal
  });
  var child;
  if (center && content) {
    child = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Content["default"], {
      style: (0, _objectSpread2["default"])({
        boxSizing: "inherit"
      }, contentStyle),
      children: children
    });
  } else {
    child = children;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restProps), {}, {
    cssList: [{
      cssModule: ["dimmer"],
      cssGroup: "semantic"
    }],
    className: classes,
    children: child
  }));
};
var _default = exports["default"] = Dimmer;
module.exports = exports.default;